module.exports = __webpack_public_path__ + "static/media/opportunityIcon.d7efb804.svg";